import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect, createContext, useContext } from 'react'
import { getOBCustomerClientModel, getOBCustomerSubmissionModel } from '../models/OpenBankingCustomerModel';
import { UserContext } from "./user-context";

import {
    generateAppToken,
    generateUserName,
    activateCustomer,
 } from "../utilities/ob-utils";

import {
    svc_getOBCustomer,
    svc_updateOBCustomer,
} from '../services/internal-openbanking.service';

const OBCustomerContext = createContext(null);

const OBCustomerProvider = ({ children }) => {
    const { getAccessTokenSilently, user } = useAuth0();
    const [obAppToken, setOBAppToken] = useState('');
    const [obCustomer, setOBCustomer] = useState(null);
    const { ddUser } = useContext(UserContext);

    const getOBCustomer = async () => {
        const accessToken = await getAccessTokenSilently();
        const { data, error } = await svc_getOBCustomer(accessToken, user?.sub);

        if (error) {
            console.error('error', error);
            throw new Error(error);
        }

        if (!data || data.length === 0) {
            const token = await generateAppToken(accessToken);
            setOBAppToken(token);

            const username = generateUserName(user.email);

            activateCustomer(
                username,
                token,
                accessToken,
                user.sub,
                setOBCustomer
            );
        } else {
            const obCustomerObj = getOBCustomerClientModel(data[0]);

            setOBAppToken(data[0].ob_token);

            setOBCustomer(obCustomerObj);
        }
    };

    const updateOBCustomer = async (updatedToken) => {
        const accessToken = await getAccessTokenSilently();
        const updatedUser = {
            ...obCustomer,
            obToken: updatedToken
        }

        setOBCustomer(updatedUser);

        const { data, error } = await svc_updateOBCustomer(accessToken, user.sub, getOBCustomerSubmissionModel(updatedUser, updatedToken));

        if (error) {
            console.error('error', error);
            throw new Error(error);
        }
    };

    useEffect(() => {
        if (user && ddUser && !obCustomer) {
            getOBCustomer();
        }
    }, [user, obCustomer, ddUser]);

    return (
        <OBCustomerContext.Provider value={{
            obAppToken,
            setOBAppToken,
            obCustomer,
            updateOBCustomer
        }}>
            {children}
        </OBCustomerContext.Provider>
    )
}

export { OBCustomerContext, OBCustomerProvider }
